// Lib Imports
import * as React from 'react';
import { Menu, Text } from 'grommet';
import PropTypes from 'prop-types';

// Core Imports
import useStatusTransition from 'granite-admin/utils/useStatusTransition';
export const StatusMenuCell = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(({
  cell: {
    value,
    row,
    column
  },
  updateCellData,
  columnId
}, ref) => {
  const {
    statusEntity,
    id
  } = column;
  if (!statusEntity) {
    console.info('StatusMenuCell requires a statusEntity');
    throw new Error('StatusMenuCell requires a statusEntity');
  }
  const initialStatus = React.useMemo(() => {
    if (!row.original?.pk && !value) return undefined;
    return value;
  }, [row.original, value]);
  const {
    allowedTransitions,
    fromStatusLabel
  } = useStatusTransition({
    entity: statusEntity,
    fromStatus: initialStatus
  });
  return /*#__PURE__*/React.createElement("span", {
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement(Menu, {
    size: "small",
    label: /*#__PURE__*/React.createElement(Text, null, fromStatusLabel),
    dropProps: {
      restrictFocus: false
    },
    items: allowedTransitions?.map?.(i => ({
      label: i.label,
      onClick: e => {
        e.stopPropagation();
        updateCellData(row.original, columnId || id, i.pk);
      }
    })) ?? []
  }));
}));
StatusMenuCell.displayName = 'StatusMenuCell';
StatusMenuCell.propTypes = {
  cell: PropTypes.object,
  updateCellData: PropTypes.func,
  columnId: PropTypes.string
};